// 公共方法
import type { AxiosRequestConfig } from 'axios';

export const INSTANCE_CONFIG: AxiosRequestConfig = {
  baseURL: '/',
  method: 'post',
  withCredentials: true,
  timeout: 30 * 60 * 1000,
  maxContentLength: 5 * 1000 * 1000,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  validateStatus() {
    return true;
  },
  // options: {},
};

export const ERROR_CODE_MESSAGE: Record<number, string> = {
  999: 'System Error.',
};
